import { forwardRef, type TextareaHTMLAttributes } from 'react'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
  label?: string
  description?: string
  errorMessage?: string
  required?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  error,
  label,
  description,
  errorMessage,
  required,
  size = 'md',
  className,
  ...props
}, ref) => {
  const sizeClass = size === 'sm' ? 'v3-textarea-sm' : size === 'lg' ? 'v3-textarea-lg' : ''

  const textarea = (
    <textarea
      ref={ref}
      className={`v3-textarea ${error || errorMessage ? 'v3-textarea-error' : ''} ${sizeClass} ${className || ''}`}
      aria-invalid={error || !!errorMessage}
      {...props}
    />
  )

  if (label || errorMessage) {
    return (
      <div className="v3-field">
        {label && (
          <label className="v3-field-label">
            {label}
            {required && <span className="v3-field-required">*</span>}
          </label>
        )}
        {description && <p className="v3-field-desc">{description}</p>}
        {textarea}
        {errorMessage && <p className="v3-field-error">{errorMessage}</p>}
      </div>
    )
  }

  return textarea
})

Textarea.displayName = 'Textarea'
